import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogOptions } from '../../../../features/confirm-dialog';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DeleteButtonComponent {
    @Input() public variant: 'icon' | 'tree' | 'tools' = 'icon';
    @Input() public isDisabled = false;
    @Input() public itemName?: string;
    @Input() public warningText?: string;

    @Output() public delete = new EventEmitter<void>();

    public constructor(private readonly translateService: TranslateService) {}

    public get confirmOptions(): ConfirmDialogOptions {
        const baseOptions: ConfirmDialogOptions = {
            confirmButtonText: this.translateService.instant('translate_yes'),
            cancelButtonText: this.translateService.instant('translate_cancel'),
            showCancelButton: true,
            showCloseButton: true,
            icon: 'warning',
        };

        return {
            ...baseOptions,
            title: this.translateService.instant(
                'translate_are_you_sure_you_want_to_delete_this_item_colon_name_question_mark'
            ),
            text: this.getConfirmText(),
        };
    }

    private getConfirmText(): string {
        const texts = [this.itemName, this.warningText]
            .map(text => text?.trim())
            .filter(text => !!text);

        return texts.join(' , ');
    }
}
